import { useEffect } from "react";
import { useSettings } from "../../hooks/useCatalog";

// Fulfils scope §16 "Analytics Integration": injects the header/body code
// snippets an admin saves in Admin > Settings (e.g. Google Analytics / GTM).
// Scripts must be re-created for the browser to execute them.
function injectSnippet(html, target, marker) {
  if (!html || !html.trim()) return;
  if (document.querySelector(`[data-hgh-analytics="${marker}"]`)) return;

  const temp = document.createElement("div");
  temp.innerHTML = html;

  Array.from(temp.childNodes).forEach((node) => {
    let el;
    if (node.nodeName === "SCRIPT") {
      el = document.createElement("script");
      Array.from(node.attributes).forEach((a) => el.setAttribute(a.name, a.value));
      el.text = node.textContent;
    } else {
      el = node.cloneNode(true);
    }
    if (el.setAttribute) el.setAttribute("data-hgh-analytics", marker);
    target.appendChild(el);
  });
}

export default function AnalyticsInjector() {
  const { data: settings } = useSettings();

  useEffect(() => {
    if (!settings) return;
    injectSnippet(settings.analyticsHeaderCode, document.head, "header");
    injectSnippet(settings.analyticsBodyCode, document.body, "body");
  }, [settings]);

  return null;
}
